// Safe JSON parsing helper, split out of components/JsonTree.tsx so that file
// only exports a component (react-refresh/only-export-components).

/**
 * Safely parse a possibly-null JSON string. Returns the parsed value, or — when
 * the string is null/empty/invalid — the original string (so callers can still
 * show non-JSON text) or `undefined` for null/empty input.
 */
export function parseJsonSafe(raw: string | null | undefined): unknown {
  if (raw == null) return undefined;
  const trimmed = raw.trim();
  if (trimmed.length === 0) return undefined;
  try {
    return JSON.parse(trimmed) as unknown;
  } catch {
    // Not JSON — hand back the raw string so it can still be displayed.
    return raw;
  }
}
